import { Component, Vue } from "vue-property-decorator";
import UlContentHeader from "@/components/UlContentHeader.vue";
import UlBreadcrumbs from "@/components/UlBreadcrumbs.vue";
import UIDataTable from "@/components/UIDataTable.vue";
import UIDatePicker from "@/components/UIDatePicker.vue";
import { DEFAULT_TABLE_OPTIONS, TableOptions } from "@/api/request";
import { SearchRequest } from "@/api/schedule-shop/request";
import { SearchItem } from "@/api/schedule-shop/response";
import ScheduleShopSearch from "@/store/schedule-shop/search";
import ScheduleShopGet from "@/store/schedule-shop/get";
import Flash, { ErrorAlert } from "@/store/common/flash";

@Component({
  components: {
    UlContentHeader,
    UlBreadcrumbs,
    UIDataTable,
    UIDatePicker
  }
})
export default class index extends Vue {
  // ------------
  // 固定値
  // ------------
  // タイトル
  headingMain = "アプリ内通知";
  headingSub = "App notification";
  breadCrumbs = [
    { text: "アピール", disabled: true },
    { text: "アプリ内通知", disabled: true },
    { text: "店舗一覧", disabled: true }
  ];

  // テーブルヘッダ
  tableHeaders = [
    { text: "店舗ID", value: "id" },
    { text: "店舗名", value: "name" },
    {
      text: "",
      value: "custom",
      sortable: false
    }
  ];

  menuProps = {
    closeOnClick: false,
    closeOnContentClick: false,
    disableKeys: true,
    openOnClick: false,
    maxHeight: 304
  };

  // ------------

  // ------------
  // 変動値
  // ------------
  // ローディングステータス
  isLoading = false;

  // 検索入力オプション
  inputOptions = {
    searchShopId: null as number | null,
    selectShopIds: null as number[] | null
  };

  // テーブル検索オプション（UIDataTableコンポーネントに渡す）
  tableOptions = DEFAULT_TABLE_OPTIONS;

  // ------------

  /**
   * テーブルに表示するアイテムリスト
   */
  get tableItems() {
    return ScheduleShopSearch.getItems;
  }

  /**
   * 総件数
   */
  get totalCount() {
    return ScheduleShopSearch.getTotalCount;
  }

  get shopItems() {
    return ScheduleShopGet.getItems;
  }

  /**
   * createdライフサイクルフック（UIDataTableコンポーネントに渡す）
   */
  async created() {
    //await ScheduleShopSearch.restore(this.inputOptions as SearchRequest);
    const request = ScheduleShopSearch.getSearchRequest;
    // 検索入力オプション
    request.searchShopId &&
      (this.inputOptions.searchShopId = request.searchShopId);
    request.selectShopIds &&
      (this.inputOptions.selectShopIds = request.selectShopIds);

    // 検索テーブルオプション
    request.page && (this.tableOptions = request);
    await this.search();
  }

  /**
   * beforeDestroyライフサイクルフック
   */
  async beforeDestroy() {
    await ScheduleShopSearch.clearResponse();
    await ScheduleShopGet.clearResponse();
  }

  /**
   * ページング変更コールバック
   *
   * @param tableOptions TableOptions
   */
  async tableChangeCallback(tableOptions: TableOptions) {
    // 子コンポーネントへpagingOptionsの変更が通知される
    this.tableOptions = tableOptions;
    await this.search();
  }

  /**
   * 検索ボタンがクリックされた際のコールバック
   */
  async searchClickCallback() {
    await Flash.clear();
    await this.search();
  }

  /**
   * テーブル行のカスタムボタンがクリックされた際のコールバック
   *
   * @param item 選択行のAdminItem
   */
  async customClickCallback(item: SearchItem) {
    await this.$router.push({
      name: "app-notification-list",
      params: { id: item.id },
      query: { shopName: item.name }
    });
  }

  /**
   * テーブル行のアクションボタンがクリックされた際のコールバック
   *
   * @param item 選択行のAdminItem
   */
  async actionClickCallback(item: SearchItem) {}

  /**
   * テーブル行の編集ボタンがクリックされた際のコールバック
   *
   * @param item 選択行のAdminItem
   */
  editClickCallback(item: SearchItem) {}

  /**
   * テーブル行の削除ボタンがクリックされた際のコールバック
   *
   * @param item 選択行のAdminItem
   */
  deleteClickCallback(item: SearchItem) {}

  /**
   * 店舗情報の一覧を取得する処理
   */
  async fetchShopList(): Promise<boolean> {
    if (ScheduleShopGet.isSuccess) {
      return true;
    }

    await ScheduleShopGet.get();
    if (!ScheduleShopGet.isSuccess) {
      await Flash.setErrorNow({
        message: ScheduleShopGet.getMessage,
        showReloadButton: false
      } as ErrorAlert);
    }
    return ScheduleShopGet.isSuccess;
  }

  /**
   * 検索処理
   */
  async search() {
    this.isLoading = true;
    let isSuccess = await this.fetchShopList();
    if (!isSuccess) {
      this.isLoading = false;
      return;
    }

    let request = this.createRequest();
    await ScheduleShopSearch.search(request);
    if (!ScheduleShopSearch.isSuccess) {
      await Flash.setErrorNow({
        message: ScheduleShopSearch.getMessage,
        showReloadButton: true
      } as ErrorAlert);
    }
    this.isLoading = false;
  }

  /**
   * dataから検索用のリクエストを作成する
   */
  private createRequest(): SearchRequest {
    const request = this.tableOptions as SearchRequest;
    if (this.inputOptions.searchShopId) {
      request.searchShopId = this.inputOptions.searchShopId;
    } else {
      delete request.searchShopId;
    }

    if (this.inputOptions.selectShopIds) {
      request.selectShopIds = this.inputOptions.selectShopIds;
    } else {
      delete request.selectShopIds;
    }

    return request;
  }
}
